import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  getFieldError,
  isFieldInvalid,
  isFieldValid,
  isOptionalFieldSuccess
} from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-related-person',
  templateUrl: './related-person.component.html',
  styleUrls: ['./related-person.component.scss']
})
export class RelatedPersonComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() view = 'agent';
  @Input() label = '';
  @Input() readonly = false;
  @Input() required = false;

  @Input() nameName = '';
  @Input() nameLabel = '';
  @Input() namePlaceholder = '';

  @Input() ageName = '';
  @Input() ageLabel = '';
  @Input() agePlaceholder = '';
  @Input() ageErrorData: any;

  @Input() nameNotValidMessage = '';

  @Input() removeLabel = '';
  @Input() removeFill: 'default' | 'clear' | 'outline' = 'clear';
  @Input() removeSize: 'medium' | 'small' | 'tiny' = 'tiny';
  @Input() removeIcon = 'assets/icons/delete.svg';
  @Input() removeIconPosition: 'left' | 'right' = 'left';
  @Output() removeItem = new EventEmitter();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;
  isOptionalFieldSuccess = isOptionalFieldSuccess;

  remove(): void {
    if (!this.readonly) {
      this.removeItem.emit();
    }
  }
}
